<template>
    <v-dialog v-model="show" max-width="500px">
        <v-card v-if="show">
            <v-card-text class="pb-0">
                <v-row>
                    <v-col cols="12" sm="6" md="6">
                        <v-select 
                            v-model="$data._category" 
                            label="카테고리" placeholder=" " hide-details 
                            :items="categories" item-text="name" item-value="_id"
                            @change="$data._platform = undefined;">
                        </v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                        <v-select 
                            v-model="$data._platform"
                            :items="platforms" item-text="name" item-value="_id" 
                            label="플랫폼" placeholder=" " hide-details>
                        </v-select>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="cancel">취소</v-btn>
                <v-btn color="blue" text @click="update" :disabled="!$data._platform">변경</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
export default {
    data(){
        return {
            show: false,

            categories: [],

            filter: {},
            pins: undefined,
            all: false,

            _category: null,
            _platform: null
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        async init(){
            var { me } = await api.console.me.get();
            this.categories = me.categories;
        },
        clear(){
            this.$data._category = null;
            this.$data._platform = null;
        },
        open(){
            this.show = true;
        },
        close(){
            this.clear();
            this.show = false;
        },
        cancel(){
            this.close();
        },
        validate(){
            try{
                if(!this.all && !this.pins?.length) throw new Error("핀을 선택해주세요");
                
                return true;
            }
            catch(error){
                alert(error.message);
            }
            return false;
        },
        async update(){
            if(this.validate()){
                await api.console.pins.platform(
                    {
                        _category: this.$data._catagory,
                        _platform: this.$data._platform,
                        pins: this.pins
                    }, 
                    { params: this.filter }
                );
    
                this.$emit("update");
                this.close();
            }
        }
    },
    computed: {
        platforms(){
            return this.categories.find(({ _id: _category }) => _category == this.$data._category)?.platforms ?? [];
        }
    }
}
</script>